export const Cities = [
  {
    name: "Seattle",
    coordinates: [-122.3321, 47.6062],
  },
  {
    name: "San Francisco",
    coordinates: [-122.4194, 37.7749],
  },
  {
    name: "Las Vegas",
    coordinates: [-115.1398, 36.1699],
  },
  {
    name: "Los Angeles",
    coordinates: [-118.2437, 34.0522],
  },
  {
    name: "Phoenix",
    coordinates: [-112.074, 33.4484],
  },
  {
    name: "Denver",
    coordinates: [-104.9903, 39.7392],
  },
  {
    name: "Dallas",
    coordinates: [-96.797, 32.7767],
  },
  {
    name: "Houston",
    coordinates: [-95.3698, 29.7604],
  },
  {
    name: "Kansas City",
    coordinates: [-94.5786, 39.0997],
  },
  {
    name: "Minneapolis",
    coordinates: [-93.265, 44.9778],
  },
  {
    name: "Chicago",
    coordinates: [-87.6298, 41.8781],
  },
  {
    name: "Louisville",
    coordinates: [-85.7585, 38.2527],
  },
  {
    name: "Atlanta",
    coordinates: [-84.388, 33.749],
  },
  {
    name: "Orlando",
    coordinates: [-81.3792, 28.5383],
  },
  {
    name: "Washington",
    coordinates: [-77.0369, 38.9072],
  },
  {
    name: "New York",
    coordinates: [-74.006, 40.7128],
  },
  {
    name: "Memphis",
    coordinates: [-90.04898, 35.14953],
  },
  {
    name: "San Antonio",
    coordinates: [-98.49363, 29.42412],
  },
  {
    name: "Boston",
    coordinates: [-71.05888, 42.36008],
  },
  {
    name: "Pittsburgh",
    coordinates: [-79.99589, 40.44062],
  },
  {
    name: "Charlotte",
    coordinates: [-80.84313, 35.22709],
  },
  {
    name: "Salt Lake City",
    coordinates: [-111.89105, 40.76078],
  },
  {
    name: "Spokane",
    coordinates: [-117.42605, 47.65878],
  },
  {
    name: "Portland",
    coordinates: [-122.67648, 45.52306],
  },
  {
    name: "Boise",
    coordinates: [-116.20231, 43.61502],
  },
  {
    name: "Buffalo",
    coordinates: [-78.87837, 42.88645],
  },
];
